var map = {
	"./Server-Busy.None.svg": 38079,
	"./Server-Busy.OfflineDrop.svg": 60752,
	"./Server-Busy.Ssh.svg": 49857,
	"./Server-Busy.TentacleActive.svg": 36892,
	"./Server-Busy.TentaclePassive.svg": 93951,
	"./Server-CalamariNeedsUpgrade.Ssh.svg": 84491,
	"./Server-CalamariNeedsUpgrade.TentacleActive.svg": 71430,
	"./Server-CalamariNeedsUpgrade.TentaclePassive.svg": 47234,
	"./Server-Default.AzureCloudService.svg": 89794,
	"./Server-Default.AzureServiceFabricCluster.svg": 36255,
	"./Server-Default.AzureSubscription.svg": 64578,
	"./Server-Default.AzureWebApp.svg": 790,
	"./Server-Default.Kubernetes.svg": 89883,
	"./Server-Default.None.svg": 19577,
	"./Server-Default.OfflineDrop.svg": 92834,
	"./Server-Default.Ssh.svg": 52157,
	"./Server-Default.TentacleActive.svg": 36617,
	"./Server-Default.TentaclePassive.svg": 96337,
	"./Server-Disabled.AzureCloudService.svg": 25742,
	"./Server-Disabled.AzureServiceFabricCluster.svg": 28917,
	"./Server-Disabled.AzureSubscription.svg": 40896,
	"./Server-Disabled.AzureWebApp.svg": 58645,
	"./Server-Disabled.Kubernetes.svg": 13639,
	"./Server-Disabled.None.svg": 68812,
	"./Server-Disabled.OfflineDrop.svg": 94461,
	"./Server-Disabled.Ssh.svg": 9957,
	"./Server-Disabled.TentacleActive.svg": 76208,
	"./Server-Disabled.TentaclePassive.svg": 33723,
	"./Server-HasWarnings.Ssh.svg": 44972,
	"./Server-HasWarnings.TentacleActive.svg": 67832,
	"./Server-HasWarnings.TentaclePassive.svg": 25507,
	"./Server-Healthy.AzureCloudService.svg": 48349,
	"./Server-Healthy.AzureServiceFabricCluster.svg": 91420,
	"./Server-Healthy.AzureSubscription.svg": 27659,
	"./Server-Healthy.AzureWebApp.svg": 3878,
	"./Server-Healthy.Kubernetes.svg": 33462,
	"./Server-Healthy.None.svg": 11977,
	"./Server-Healthy.OfflineDrop.svg": 44947,
	"./Server-Healthy.Ssh.svg": 58430,
	"./Server-Healthy.TentacleActive.svg": 79799,
	"./Server-Healthy.TentaclePassive.svg": 95636,
	"./Server-NeedsUpgrade.TentacleActive.svg": 38468,
	"./Server-NeedsUpgrade.TentaclePassive.svg": 89418,
	"./Server-Unavailable.AzureCloudService.svg": 64082,
	"./Server-Unavailable.AzureServiceFabricCluster.svg": 69240,
	"./Server-Unavailable.AzureSubscription.svg": 60687,
	"./Server-Unavailable.AzureWebApp.svg": 24159,
	"./Server-Unavailable.Kubernetes.svg": 64675,
	"./Server-Unavailable.OfflineDrop.svg": 64196,
	"./Server-Unavailable.Ssh.svg": 51717,
	"./Server-Unavailable.TentacleActive.svg": 39205,
	"./Server-Unavailable.TentaclePassive.svg": 37606,
	"./Server-Unhealthy.AzureCloudService.svg": 89921,
	"./Server-Unhealthy.AzureServiceFabricCluster.svg": 15042,
	"./Server-Unhealthy.AzureWebApp.svg": 83330,
	"./Server-Unhealthy.Kubernetes.svg": 67635,
	"./Server-Unhealthy.OfflineDrop.svg": 15212,
	"./Server-Unhealthy.Ssh.svg": 75029,
	"./Server-Unhealthy.TentacleActive.svg": 66455,
	"./Server-Unhealthy.TentaclePassive.svg": 259,
	"./Server-Unknown.AzureCloudService.svg": 50857,
	"./Server-Unknown.AzureServiceFabricCluster.svg": 14417,
	"./Server-Unknown.AzureSubscription.svg": 89136,
	"./Server-Unknown.AzureWebApp.svg": 18504,
	"./Server-Unknown.Kubernetes.svg": 8097,
	"./Server-Unknown.None.svg": 98660,
	"./Server-Unknown.OfflineDrop.svg": 11958,
	"./Server-Unknown.Ssh.svg": 53132,
	"./Server-Unknown.TentacleActive.svg": 10849,
	"./Server-Unknown.TentaclePassive.svg": 26138,
	"./Server-Warning.OfflineDrop.svg": 37136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90768;